










































import { Component, Vue } from "vue-property-decorator";
import { Constants, Console, Events } from "@/common/global.ts";

import BasePage from "@/common/base-page.ts";

import UIHeaderBasic from "@/views/ui/HeaderBasic.vue";
import UIFooter from "@/views/ui/Footer.vue";
import UINavigation from "@/views/ui/Navigation.vue";
import UIShareModal from "@/views/ui/ShareModal.vue";

@Component({
    components: {
        UIHeaderBasic,
        UIFooter,
        UINavigation,
        UIShareModal,
    },
})
export default class Share extends BasePage {

    /**
     * [signUrl description]
     *
     * @type {[type]}
     */
    public signUrl: string = "";

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        super.mounted();

        const sign: string = window.nao_astrologicalSign || "cancer";

        this.signUrl = [
            window.desman_obs_ext_url,
            window.desman_obs_bucket,
            "/assets/videos/nao_orbit_",
            sign.toLowerCase(),
            ".mp4",
        ].join("");

        this.log("Share URL: " + this.signUrl);
    }


    // Animation
    // -----------------------------------------------------------------

    /**
     * [AnimateOut description]
     *
     * @param {[type]} onComplete: any [description]
     */
    public AnimateOut(onComplete: any = null): void {
        super.AnimateOut();

        setTimeout(onComplete, 500);
    }


    // Event Handlers
    // -----------------------------------------------------------------

    private Handle_OnOpenModal(e: MouseEvent): void {
        const shareModal: HTMLDivElement = <HTMLDivElement> this.$refs.ShareModal;
        const $el: UIShareModal = <UIShareModal> this.$refs.ShareModal;

        $el.open();
    }

}
